// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"268":"events","353":"contact","543":"gallery","594":"about","671":"services"}[chunkId] + "." + {"268":"bb7aaf72","353":"8c668f26","543":"24b151f6","594":"c7b9fc12","671":"85da285c"}[chunkId] + ".js";
};